import { createApp } from 'vue'
import App from './App.vue'
import './style/tailwind.css'
import 'flowbite/dist/flowbite.js'
import 'flowbite/dist/flowbite.css'
import SvgIcon from 'vue3-icon'
import { createPinia } from 'pinia'
import mitt from 'mitt'

import router from '@/router'
import DefaultApp from '@/layout/Default.vue'
import NoHeaderFooter from '@/layout/NoHeaderFooter.vue'
import Admin from '@/layout/Admin.vue'
import Order from "@/layout/Order.vue";
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueApexCharts from "vue3-apexcharts";

const emitter = mitt();

const app = createApp(App)
app.config.globalProperties.emitter = emitter
app.component('default-layout', DefaultApp)
    .component('svg-icon', SvgIcon)
    .component('no-header-footer-layout', NoHeaderFooter)
    .component('header-order-layout', Order)
    .component('admin-layout', Admin)
    .use(createPinia())
    .use(router)
    .use(VueApexCharts)
    .use(Vue3Toastify, {
        autoClose: 3000
    })
    .mount('#app')
